//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DoNotFlagHtmlNewlineFalsePositives: FeatureFlag = {"Id":"DoNotFlagHtmlNewlineFalsePositives","Label":"[10.20]Ignore newline-only HTML-like false positives","Impact":"Avoid flagging inputs where only newline/line-ending differences trigger the HTML-like scanner; enables relaxed newline normalization handling in the malicious-content scanner.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
